<template>
  <v-app>
    <v-main>
      <GlobalLoading ref="globalLoading" />
      <router-view></router-view>
      <Notification ref="notification" />
      <!-- <v-footer color="transparent" >
        <v-row >
          <v-col
            :class="[
              $vuetify.breakpoint.smAndDown ? 'text-center' : 'text-left',
            ]"
            cols="12"
            lg="6"
            md="4"
            sm="8"
            justify="left"
            class="justify-sm-center"
          >
            <span class="label">© byvisit.com</span>
          </v-col>
          <v-col
            :class="[
              $vuetify.breakpoint.smAndDown ? 'text-center' : 'text-right',
            ]"
            cols="12"
            lg="6"
            md="4"
            sm="8"
            justify="right"
          >
            <span class="label ">
              Read our
              <a color="cyan accent-3" href="https://byvisit.com/policy/privacy"> Privacy policy</a>
            </span>
          </v-col>
        </v-row>
      </v-footer> -->
    </v-main>

  </v-app>
</template>

<script>
import Notification from './components/global_notifications.vue';

export default {
  name: "App",
  theme: { dark: true },
  components: { Notification },

  data: () => ({
    //
  }),
  beforeCreate() {
    this.$vuetify.theme.dark = true;
  },
  mounted() {
    this.$eventBus.$on('showLoading', () => {
      this.$refs.globalLoading.show();
    });

    this.$eventBus.$on('hideLoading', () => {
      this.$refs.globalLoading.hide();
    });
  },
  created() {
    this.$root.$notify = this.notify;
  },
  methods: {
    notify(message, typeIndex = 1, duration = 4000) {
      this.$refs.notification.show(message, typeIndex, duration);
    },
  },

};
</script>
<style>
html {
  font-size: 16px;
}

@media (min-width: 1904px) {
  .container {
    max-width: 1185px;
  }
}

.v-navigation-drawer__content,
.theme--dark.v-application {
  background-color: var(--v-background-base, #000000) !important;
  color: #6a7a7a !important;
}

.theme--dark.v-application p,
.text-caption .outlined {
  color: #6a7a7a !important;
}

.v-application .subtitle-1 {
  font-size: 18px;
  color: #6a7a7a;
}

.text-box {
  color: #5dcce0;
  border-radius: 15px;
  border-color: #000000;
}

.main .a {
  color: #5dcce0 !important;
}

.outlined {
  color: #6a7a7a !important;
}

.v-toolbar__items .v-btn--active::before {
  background-color: transparent !important;
}

html,
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.label {
  color: #6a7a7a !important;
}

footer {
  background-color: #0d121600 !important;
}

.list {
  list-style-type: none;
  padding: 0 !important;
}

.list li {
  margin: 16px 0 !important;
}

.list li a {
  text-decoration: none;
  color: #6a7a7a !important;
}

.button {
  border-radius: 10px;
}

.button .v-btn__content {
  color: #ffffff;
  padding: 5px 0;
}

:root {
  color-scheme: dark;
}

.click_dialog {
  background-color: #0e1111 !important;
}

.toolbar_dialog {
  background-color: #202828 !important;
}

.v-application .primary--text {
  color: #5dcce0 !important;
  caret-color: #5dcce0 !important;
}

.v-list .v-list-item--active {
  color: #5dcce0 !important;
}

.theme--dark.v-input input::placeholder,
.theme--dark.v-input textarea {
  color: #566767;
}

.text-box {
  color: #5dcce0;
  border-radius: 15px;
  border-color: #000000;
}
</style>
